import React, { useState } from 'react';
import { 
  Chip, 
  Tooltip,
  Typography,
  Box
} from '@mui/material';
import { 
  CheckCircle as HealthyIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  HelpOutline as UnknownIcon
} from '@mui/icons-material';
import { useHealth } from '../contexts/HealthContext';
import HealthDetailModal from './HealthDetailModal';

const HealthStatusChip = ({ environmentId, size = 'medium', showLabel = true, clickable = true, showDetails = false }) => {
  const { getCurrentEnvironmentDisplay, getHealthDisplay } = useHealth();
  const [detailsOpen, setDetailsOpen] = useState(false);
  
  // Als environmentId is opgegeven, gebruik die, anders gebruik current environment
  const healthDisplay = environmentId ? getHealthDisplay(environmentId) : getCurrentEnvironmentDisplay();
  
  const getIcon = () => {
    switch (healthDisplay.status) {
      case 'healthy':
        return <HealthyIcon />;
      case 'warning':
      case 'degraded':
        return <WarningIcon />;
      case 'unhealthy':
      case 'unreachable':
        return <ErrorIcon />;
      default:
        return <UnknownIcon />;
    }
  };

  const handleClick = () => {
    if (!clickable) return;
    setDetailsOpen(true);
  };

  const handleClose = () => {
    setDetailsOpen(false);
  };

  return (
    <>
      <Tooltip title={`Environment status: ${healthDisplay.label}${clickable ? ' (Klik voor gedetailleerde health info)' : ''}`}>
        <Chip
          icon={getIcon()}
          label={showLabel ? healthDisplay.label : undefined}
          color={healthDisplay.color === 'success.main' || healthDisplay.color === 'success' ? 'success' : 
                 healthDisplay.color === 'warning.main' || healthDisplay.color === 'warning' ? 'warning' : 
                 healthDisplay.color === 'error.main' || healthDisplay.color === 'error' ? 'error' : 'default'}
          size={size}
          clickable={clickable}
          onClick={clickable ? handleClick : undefined}
          sx={{
            cursor: clickable ? 'pointer' : 'default'
          }}
        />
      </Tooltip>

      {/* Health Detail Modal met auto-refresh elke 5 seconden */}
      <HealthDetailModal 
        open={detailsOpen} 
        onClose={handleClose}
        environmentId={environmentId}
      />
    </>
  );
};

export default HealthStatusChip; 